import React, { Component } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { setViewstate, fetchArticlePageView, removeViewstate, fetchCampaignProducts } from '../actions/actionCreators';
import { getProductsByArray } from '../selectors/reselectCategory';
import Page from './Page';
import { color } from '../styles/helpers/variables';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import { Container } from '../styles/Container';
import ProductListWithFilters from '../components/ProductListWithFilters';
import NotFoundPage from './NotFoundPage';
import ErrorPage from './ErrorPage';

class ProductListPage extends Component {
  componentDidMount() {
    const pageUrl = this.props.location.pathname;
    this.props.fetchArticlePageView({ urlPath: pageUrl });

    const productListId = this.props.currentPage.getIn(['fields', 'productListId', 'id']);
    if (productListId) {
      this.props.fetchCampaignProducts({
        id: productListId,
        url: pageUrl
      });
    }

    this.setDefaultFilters(pageUrl);
  }

  componentDidUpdate() {
    const pageUrl = this.props.location.pathname;
    const productListId = this.props.currentPage.getIn(['fields', 'productListId', 'id']);

    if (this.props.productsRequest.isEmpty() && productListId) {
      this.props.fetchCampaignProducts({
        id: productListId,
        url: pageUrl
      });

      this.setDefaultFilters(pageUrl);
    }
  }

  setDefaultFilters(categoryId) {
    const { currentCategory } = this.props;
    if (currentCategory !== categoryId) {
      this.props.setViewstate('currentCategory', categoryId);
      this.props.setViewstate('sortAscending', false);
      this.props.setViewstate('sortBy', 'name');
      this.props.removeViewstate('filter');
      this.props.setViewstate('pagination', 0);
    }
  }

  render() {
    const { request, productsRequest, campaignProducts } = this.props;

    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;

    return (
      <Page meta={this.props.currentPage.get('metaData')} bgColor={color.lightGrey}>
        <Container>
          <Heading big center>
            {this.props.currentPage.getIn(['fields', 'title'])}
          </Heading>
          <Preamble>{this.props.currentPage.getIn(['fields', 'introduction'])}</Preamble>
        </Container>
        <ProductListWithFilters includeCategoryFilter request={productsRequest} allProducts={campaignProducts} />
      </Page>
    );
  }
}

ProductListPage.defaultProps = {
  campaignProducts: Map(),
  currentPage: Map(),
  request: Map(),
  productsRequest: Map(),
  currentCategory: undefined
};

ProductListPage.propTypes = {
  fetchArticlePageView: PropTypes.func.isRequired,
  setViewstate: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  fetchCampaignProducts: PropTypes.func.isRequired,
  campaignProducts: PropTypes.instanceOf(Map),
  currentPage: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  productsRequest: PropTypes.instanceOf(Map),
  currentCategory: PropTypes.string
};

export default connect(
  ProductListPage,
  { setViewstate, fetchArticlePageView, removeViewstate, fetchCampaignProducts },
  (store, props) => {
    const currentPage = store.page.data.get(props.location.pathname, Map());
    const listId = currentPage.getIn(['fields', 'productListId', 'id'], '');
    const campaignProductIds = store.campaign.get(listId);
    const campaignProducts = getProductsByArray(store, campaignProductIds);
    return {
      currentPage,
      request: store.page.request.get(props.location.pathname),
      campaignProducts,
      productsRequest: store.products.request.get(props.location.pathname),
      currentCategory: store.viewstate.get('currentCategory')
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/ProductListPage.js